import React, { memo, forwardRef } from "react";
const SvgPermutations = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.52 12.34h1.76a8.35 8.35 0 001.18-.08 3.671 3.671 0 001-.32c.293-.16.527-.373.7-.64.173-.267.26-.613.26-1.04 0-.413-.087-.747-.26-1a1.752 1.752 0 00-.7-.62 2.72 2.72 0 00-.98-.28 7.636 7.636 0 00-1.12-.08h-1.84v4.06zm2.1-6.18c.813 0 1.547.073 2.2.22.653.147 1.213.387 1.68.72.467.333.827.76 1.08 1.28.253.52.38 1.147.38 1.88 0 .787-.147 1.447-.44 1.98a3.623 3.623 0 01-1.2 1.3c-.493.32-1.073.553-1.74.7a9.852 9.852 0 01-2.12.22h-1.94v4.62c0 .307-.047.553-.14.74a1.345 1.345 0 01-.34.42.815.815 0 01-.4.2c-.147.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.94.94 0 01-.42-.2 1.516 1.516 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V7.66c0-1 .5-1.5 1.5-1.5h3.12z"
      />
      <rect width={6} height={8} x={23} y={16} fill="#DBDBDB" rx={1} />
      <rect width={6} height={8} x={3} y={16} fill="#DBDBDB" rx={1} />
    </svg>
  );
});
SvgPermutations.displayName = "SvgPermutations";
const MemoForwardRef = memo(SvgPermutations);
export default MemoForwardRef;
